// test1918
(1918 && 0);
